<div
  style="
    background: url(/assets/images/backgrounds/BG-001.png) no-repeat;
    background-size: cover;
    width: 100%;
  "
  fxLayout="row"
  fxLayoutAlign="start"
>
  <div
    class="card"
    style="
      display: flex;
      flex-direction: column;
      flex: 1;
      justify-content: center;
      align-items: center;
    "
  >
    <mat-card *ngIf="!showResult" fxLayout="column" fxLayoutAlign="center">
      <form (ngSubmit)="onSubmit()" [formGroup]="aFormGroup">
        <!-- <mat-form-field style="width: 100%;" appearance="outline">
          <mat-label>{{ "Receipt No" | translate }}</mat-label>
          <input [disabled]="loading" matInput formControlName="receipt" />
        </mat-form-field> -->
        <div style="margin-bottom: 16px">
          <ngx-recaptcha2
            *ngIf="showCaptcha"
            siteKey="6Lc3QDQaAAAAAHc14iyTzg1dQKvZrxib2DTL5_tF"
            (reset)="handleReset()"
            (expire)="handleReset()"
            (success)="resolved($event)"
            hl="ta"
            [useGlobalDomain]="false"
            formControlName="recaptcha"
          >
          </ngx-recaptcha2>
        </div>

        <div
          *ngIf="showError"
          style="
            margin-bottom: 16px;
            display: flex;
            flex-direction: row;
            justify-content: center;
          "
        >
          <mat-error>{{ errorMsg | translate }}</mat-error>
        </div>

        <div
          style="display: flex; flex-direction: row; justify-content: center"
        >
          <button
            *ngIf="!loading"
            [disabled]="!enableDoneBtn"
            mat-raised-button
            color="accent"
            class="submit-button"
            type="submit"
            aria-label="LOGIN"
          >
            சரிபார்க்கவும்
          </button>
          <mat-spinner diameter="50" *ngIf="loading"></mat-spinner>
        </div>
      </form>
    </mat-card>

    <div
      *ngIf="showResult && event_level == 'constituency'"
      style="
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      "
    >
      <table id="t01">
        <tr>
          <th>{{ "Contributor" | translate }}</th>
          <td>{{ contribution_data?.contributor }}</td>
        </tr>
        <tr>
          <th>{{ "Amount" | translate }}</th>
          <td>{{ contribution_data?.amount | number }}</td>
        </tr>
        <tr>
          <th>{{ "Paid" | translate }}</th>
          <td>
            {{ (contribution_data?.paid == 1 ? "Yes" : "No") | translate }}
          </td>
        </tr>
        <tr>
          <th>{{ "ரசீது எண்" | translate }}</th>
          <td>{{ contribution_data?.receiptNum }}</td>
        </tr>

        <tr>
          <th>{{ "Date" | translate }}</th>
          <td>{{ contribution_data?.date | date: "dd-MM-yyyy" }}</td>
        </tr>

        <tr>
          <th>{{ "Updated On" | translate }}</th>
          <td>
            {{ contribution_data?.updated_on | date: "dd-MM-yyyy hh:mm:ss a" }}
          </td>
        </tr>
      </table>
      <button
        style="margin-top: 16px"
        [disabled]="!enableDoneBtn"
        mat-raised-button
        color="accent"
        class="submit-button"
        (click)="onBack()"
      >
        பின்னே செல்க
      </button>
    </div>

    <div
      *ngIf="showResult && event_level == 'country'"
      style="
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      "
    >
      <table id="t01">
        <tr>
          <th>{{ "Contributor" | translate }}</th>
          <td>{{ contribution_data?.contributor }}</td>
        </tr>
        <tr>
          <th>{{ "Domestic amount" | translate }}</th>
          <td>{{ contribution_data?.foreign_amount | number }}</td>
        </tr>
        <tr>
          <th>{{ "Amount" | translate }}</th>
          <td>{{ contribution_data?.local_amount | number }}</td>
        </tr>
        <tr>
          <th>{{ "Paid" | translate }}</th>
          <td>
            {{ (contribution_data?.paid == 1 ? "Yes" : "No") | translate }}
          </td>
        </tr>
        <tr>
          <th>{{ "பற்றுகைத்துண்டு இல" | translate }}</th>
          <td>{{ contribution_data?.receipt_manual }}</td>
        </tr>
        <tr>
          <th>{{ "Series no" | translate }}</th>
          <td>{{ contribution_data?.sl_no }}</td>
        </tr>

        <tr>
          <th>{{ "Date" | translate }}</th>
          <td>{{ contribution_data?.date | date: "dd-MM-yyyy" }}</td>
        </tr>

        <tr>
          <th>{{ "Updated On" | translate }}</th>
          <td>
            {{ contribution_data?.updated_on | date: "dd-MM-yyyy hh:mm:ss a" }}
          </td>
        </tr>
      </table>
      <button
        style="margin-top: 16px"
        [disabled]="!enableDoneBtn"
        mat-raised-button
        color="accent"
        class="submit-button"
        (click)="onBack()"
      >
        பின்னே செல்க
      </button>
    </div>
  </div>
</div>
